import React, {useEffect, useState} from "react"
import {ThemeProvider} from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import _ from "lodash"
import baseTokens from "../../anwendungskonfigurator/assets/styles/styles.json"
import customBaseTokens from "../assets/customstyles.json"
import {themeGenerator} from "../../anwendungskonfigurator/assets/theme"
import {GlobalStyles} from "@mui/material"
import TomClient from "../../anwendungskonfigurator/services/tomClient"

const defaulttokens = _.merge(baseTokens, customBaseTokens)

const DynamicThemeProvider = ({children}) => {
    const [theme, setTheme] = useState(() => themeGenerator(defaulttokens))

    useEffect(() => {
        let cancelled = false
        TomClient.getEnrich("/theme")
            .then((response) => {
                if (cancelled) return
                const designtokens = _.merge({}, defaulttokens, response?.tokens ?? {})
                setTheme(themeGenerator(designtokens))
            })
            .catch((error) =>
                console.error("[Theme] Designtokens nicht ladbar, nutze Defaults", error),
            )
        return () => {
            cancelled = true
        }
    }, [])

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <GlobalStyles
                styles={{
                    body: {
                        backgroundColor: "#eeeeee",
                    },
                }}
            />
            {children}
        </ThemeProvider>
    )
}

export default DynamicThemeProvider
